// extracted by mini-css-extract-plugin
module.exports = {"BackDrop":"BackDrop_BackDrop__2O2aY"};